import { BullModule } from '@nestjs/bullmq'
import { Module } from '@nestjs/common'
import { GOOGLE_RESERVATIONS_QUEUES } from '../../../../../core'
import { UploadFeedsCron } from './upload-feeds.cron'

@Module({
	imports: [
		BullModule.registerQueue({
			name: GOOGLE_RESERVATIONS_QUEUES.UPLOAD_MERCHANT_FEED,
		}),
		BullModule.registerQueue({
			name: GOOGLE_RESERVATIONS_QUEUES.UPLOAD_SERVICES_FEED,
		}),
		BullModule.registerQueue({
			name: GOOGLE_RESERVATIONS_QUEUES.UPLOAD_AVAILABILITY_FEED,
		}),
	],
	providers: [UploadFeedsCron],
})
export class GoogleReservationsCronModule {}
